import { Avatar, Box, Card } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import philippa from 'modules/onboarding/lib/assets/philippa.jpg'

const BookingCard = () => {
  const { email } = useCurrentSession()

  return (
    <Box alignSelf="center" style={{ width: '520px' }}>
      <Card>
        <Card.Eyebrow>
          <Avatar label="avatar" url={philippa} />
        </Card.Eyebrow>
        <Card.Title>{i18n.t('pricing_plans.success.booking_card.title')}</Card.Title>
        <Card.Description>
          {i18n.t('pricing_plans.success.booking_card.message', {
            email: email,
          })}
        </Card.Description>
      </Card>
    </Box>
  )
}

export default BookingCard
